module.exports = __webpack_public_path__ + "img/h1-4.e9de3c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/h1-4.png
// module id = BBgL
// module chunks = 15